module.exports = __webpack_public_path__ + "media/images/third-registration-background-79eb135b1ced46e9223d8843d45d387f.png";